import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#4B5563')};
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) => {
      if (props.error) return '#ef4444';
      return props.theme.name === 'dark' ? 'rgba(255,255,255,0.1)' : '#E5E7EB';
    }};
  border-radius: 6px;
  font-size: 14px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? '#ffffff'
      : props.theme.colors?.blueBlack || '#1F2937'};
  resize: vertical;
  min-height: 110px;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: ${(props) =>
      props.error ? '#ef4444' : props.theme?.colors?.primary || '#fa4616'};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.error ? 'rgba(239, 68, 68, 0.1)' : 'rgba(250, 70, 22, 0.1)'};
  }

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#9CA3AF')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Fix autofill background color in dark theme */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px
      ${(props) =>
        props.theme.name === 'dark'
          ? 'rgba(255, 255, 255, 0.05)'
          : '#ffffff'} inset !important;
    -webkit-text-fill-color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : '#1F2937'} !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const HelperText = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${(props) => (props.error ? '#ef4444' : '#64748B')};
`;
